module.exports = __webpack_public_path__ + "assets/img/ab61-ru.svg";